const mode = 'PROD';

export const API_BASE_URL =
    mode === 'DEV'
        ? 'http://localhost/melocalizae/src/php'
        : 'https://melocalizae.com.br/php';


/*LOGS*/
export const registrarLog = async (pagina, acao) => {
    // Recupera ou cria uma sessão única no dispositivo do usuário
    let sessionId = localStorage.getItem('session_id');
    if (!sessionId) {
        sessionId = crypto.randomUUID();
        localStorage.setItem('session_id', sessionId);
    }

    const response = await fetch('https://melocalizae.com.br/php/logs/registro-logs.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            pagina: pagina,
            acao: acao,
            data_hora: new Date().toISOString(),
            session_id: sessionId
        }),
    });
    const data = await response.json();
    console.log(data);
}

